module.exports = __webpack_public_path__ + "static/media/Sello_Datos.85069677.webp";